// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flag-icon[data-v-6f78b064]{height:22px;width:22px}.flag-icon.flag-round[data-v-6f78b064]{background-size:cover;border-radius:100%;height:26px;width:26px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
